import { type ReactNode } from 'react'
import { useElementSize, useMergedRef } from '@mantine/hooks'
import { Box, Center } from '@mantine/core'

type Props = {
  designWidth: number
  children: ReactNode
}

export const ScaledPreview = ({ designWidth, children }: Props): ReactNode => {
  const { ref, width } = useElementSize<HTMLDivElement>()
  const setRef = useMergedRef(ref)
  const zoom = Math.min(1, width / designWidth)

  return (
    <Center>
      <Box ref={setRef} maw={designWidth} w='100%'>
        {width > 0 && (
          <Box style={{ zoom }} w={designWidth}>
            {children}
          </Box>
        )}
      </Box>
    </Center>
  )
}
